import { useEffect, useState } from "react";
import { FaSearch, FaEdit, FaTrash, FaDownload } from "react-icons/fa"; // Added FaDownload
import Header from "../Common/AdminHeader";
import axios from "axios";
import { Config } from "../../../API/config";
import toast from "react-hot-toast";

interface TrainerDetails {
    _id: string;
    priceOfLesson: number;
}

interface Trainer {
    _id: string;
    name: string;
    trainerId: TrainerDetails;
}

interface Trainee {
    _id: string;
    name: string;
    profileImage: string | null;
}

export interface Payment {
    commission: number;
    _id: string;
    trainerId: Trainer;
    traineeId: Trainee;
    status: "opened" | "pending" | "closed";
    rate: number;
    price: number;
    createdAt: string;
    updatedAt: string;
    __v: number;
}


const Sales = () => {
    const [payments, setPayments] = useState<Payment[]>([]);
    const [filteredPayments, setFilteredPayments] = useState<Payment[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [showDropdown, setShowDropdown] = useState<string | null>(null);
    const [showModal, setShowModal] = useState<"price" | "status" | "rate" | null>(null);
    const [selectedPaymentId, setSelectedPaymentId] = useState<string | null>(null);
    const [inputValue, setInputValue] = useState<string>("");
    const [state, setState] = useState<"opened" | "closed" | "pending" | string>("pending");
    const [searchTerm, setSearchTerm] = useState<string>("");

    const fetchEnrollments = async () => {
        setLoading(true);
        try {
            let api: string = "";
            if (state === "pending") {
                api = Config.getAllPendingenrollments;
            } else if(state==="opened") {
                api = Config.getAllOpenedenrollments;
            }
            else{
                api = Config.getAllClosedenrollments;
            }
            let { data } = await axios.get(api, { withCredentials: true });


            if (data.statusCode === 200 && Array.isArray(data.data)) {
                setPayments(data.data?.reverse());
                setFilteredPayments(data.data);
            }
        } catch (err) {
            console.error("Error fetching Enrollments", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEnrollments();
    }, [state]);

    useEffect(() => {
        if (searchTerm.trim() === "") {
            setFilteredPayments(payments);
        } else {
            const filtered = payments.filter((payment) =>
                payment.traineeId.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                payment.trainerId.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredPayments(filtered);
        }
    }, [searchTerm, payments]);

    const handleEditClick = (id: string) => {
        setShowDropdown(showDropdown === id ? null : id);
        setSelectedPaymentId(id);
    };

    const handleEditField = (field: "price" | "status" | "rate") => {
        setShowModal(field);
        setShowDropdown(null);
        const payment = payments.find(p => p._id === selectedPaymentId);
        if (payment) {
            setInputValue(field === "price" ? payment.price.toString() :
                field === "rate" ? payment.rate.toString() :
                    payment.status);
        }
    };

    const handleenrolmentPriceUpdate = async (paymentId: string, updatedPrice: number) => {
        try {
            let { data } = await axios.patch(
                `${Config.updateenrollmentsPrice}/${paymentId}`,
                { price: updatedPrice },
                { withCredentials: true }
            );
            if (data.statusCode === 200) {
                toast.success("تم تحديث المبلغ");
                setInputValue("");
                setSelectedPaymentId(null);
                // fetchEnrollments();
            }
        } catch (err) {
            console.error("Error updating payment price:", err);
            toast.error("فشل في تحديث المبلغ");
        } finally {
            setShowModal(null);
        }
    };

    const handleEnrollmentStatusUpdate = async (paymentId: string, updatedStatus: string) => {
        try {
            let { data } = await axios.patch(
                `${Config.updateenrollmentsStatus}/${paymentId}`,
                { status: updatedStatus },
                { withCredentials: true }
            );
            if (data.statusCode === 200) {
                toast.success("تم تحديث الحالة");
                setInputValue("");
                setSelectedPaymentId(null);
                // fetchEnrollments();
            }
        } catch (err) {
            console.error("Error updating payment status:", err);
            toast.error("فشل في تحديث الحالة");
        } finally {
            setShowModal(null);
        }
    };

    const handleEnrollmentRateUpdate = async (paymentId: string, updatedRate: number) => {
        try {
            let { data } = await axios.patch(
                `${Config.updateenrollmentsRate}/${paymentId}`,
                { rate: updatedRate },
                { withCredentials: true }
            );
            if (data.statusCode === 200) {
                toast.success("تم تحديث التقييم");
                setInputValue("");
                setSelectedPaymentId(null);
                // fetchEnrollments();
            }
        } catch (err) {
            console.error("Error updating payment rate:", err);
            toast.error("فشل في تحديث التقييم");
        } finally {
            setShowModal(null);
        }
    };

    const handleDownloadexcel = async () => {
        try {
            const response = await axios.get(
                Config.downloadEnrollments,
                {
                    withCredentials: true,
                    responseType: 'blob',
                }
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Enrollments_${new Date().toLocaleDateString("ar-EG")}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            toast.success("تم تحميل ملف Excel بنجاح");
        } catch (err) {
            console.error("Error downloading Excel file:", err);
            toast.error("فشل في تحميل ملف Excel");
        }
    };



    const handleSave = async () => {
        if (!selectedPaymentId || !showModal) return;

        switch (showModal) {
            case "price":
                const updatedPrice = Number(inputValue);
                await handleenrolmentPriceUpdate(selectedPaymentId, updatedPrice);
                break;
            case "status":
                await handleEnrollmentStatusUpdate(selectedPaymentId, inputValue);
                break;
            case "rate":
                const updatedRate = Number(inputValue);
                await handleEnrollmentRateUpdate(selectedPaymentId, updatedRate);
                break;
            default:
                break;
        }
    };

    const handleDelete = (id: string) => {
        const confirmDelete = window.confirm("هل أنت متأكد من أنك تريد حذف هذه الدفعة؟");
        if (confirmDelete) {
            setPayments((prevPayments) => prevPayments.filter((payment) => payment._id !== id));
            setFilteredPayments((prevPayments) => prevPayments.filter((payment) => payment._id !== id));
        }
    };

    return (
        <div className="flex-1 overflow-auto relative z-10 bg-white">
            <Header title="إدارة الاشتراكات والتسجيلات" />

            <main className="max-w-80 md:max-w-7xl mx-auto md:py-6 md:px-4 lg:px-8 overflow-auto">
                <div className="p-3 md:p-6 bg-white shadow-md rounded-lg" dir="rtl">
                    {/* Filters */}
                    <div className="flex flex-col sm:flex-row items-center mb-5 gap-4">
                        <div className="relative w-full sm:max-w-xs">
                            <input
                                type="text"
                                placeholder="بحث..."
                                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-200"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
                        </div>
                        <button
                            onClick={handleDownloadexcel}
                            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition flex items-center gap-2"
                        >
                            <span>تحميل Excel</span>
                        </button>
                        <select
                            onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                                setState(event.target.value);
                            }}
                            value={state}
                            className="w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-lg bg-white shadow-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary-500 transition duration-200 ease-in-out hover:shadow-md"
                        >
                            <option value="pending" className="text-blue-700 font-semibold">قيد الانتظار</option>
                            <option value="opened" className="text-yellow-700 font-semibold">مفتوح</option>
                            <option value="closed" className="text-green-700 font-semibold">مغلق</option>
                        </select>
                    </div>

                    <div className="overflow-y-auto">
                        {loading ? (
                            <p className="text-center text-gray-600 py-6">جارٍ التحميل...</p>
                        ) : (
                            <table className="w-full border-collapse border border-gray-200 text-right text-sm sm:text-base">
                                <thead className="bg-gray-100">
                                    <tr>
                                        <th className="md:p-3 border border-gray-200">المتدرب</th>
                                        <th className="md:p-3 border border-gray-200">المدرب</th>
                                        <th className="md:p-3 border border-gray-200">المبلغ</th>
                                        <th className="md:p-3 border border-gray-200">العمولة</th>
                                        <th className="md:p-3 border border-gray-200">التاريخ</th>
                                        <th className="md:p-3 border border-gray-200">حالة الدفع</th>
                                        <th className="md:p-3 border border-gray-200">الإجراءات</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredPayments.map((payment) => (
                                        <tr key={payment._id} className="border border-gray-200">
                                            <td className="md:p-3">{payment.traineeId.name}</td>
                                            <td className="md:p-3">{payment.trainerId.name}</td>
                                            <td className="md:p-3">{payment.trainerId.trainerId.priceOfLesson} جنيه</td>
                                            <td className="md:p-3">{payment.commission} جنية</td>
                                            <td className="md:p-3">{new Date(payment.createdAt).toLocaleDateString("ar-EG")}</td>
                                            <td className="md:p-3">
                                                <span
                                                    className={`px-3 py-1 rounded-full text-xs md:text-sm font-semibold ${payment.status === "closed" ? "bg-green-200 text-green-800" :
                                                        payment.status === "pending" ? "bg-blue-200 text-blue-800" :
                                                            "bg-yellow-200 text-yellow-800"
                                                        }`}
                                                >
                                                    {payment.status === "pending" ? "قيد الانتظار" :
                                                        payment.status === "opened" ? "مفتوح" :
                                                            "مغلق"}
                                                </span>
                                            </td>
                                            <td className="md:p-3 flex items-center gap-2 relative">
                                                <button
                                                    onClick={() => handleEditClick(payment._id)}
                                                    className="p-2 bg-yellow-200 text-white rounded-full hover:bg-yellow-300 transition"
                                                    title="تعديل"
                                                >
                                                    <FaEdit />
                                                </button>
                                                {showDropdown === payment._id && (
                                                    <div className="absolute left-0 mt-2 w-40 bg-white border border-gray-200 rounded-lg shadow-lg z-10">
                                                        <button
                                                            onClick={() => handleEditField("price")}
                                                            className="block w-full text-right px-4 py-2 hover:bg-gray-100"
                                                        >
                                                            تعديل نسبة المكسب
                                                        </button>
                                                        <button
                                                            onClick={() => handleEditField("status")}
                                                            className="block w-full text-right px-4 py-2 hover:bg-gray-100"
                                                        >
                                                            تعديل الحالة
                                                        </button>
                                                        <button
                                                            onClick={() => handleEditField("rate")}
                                                            className="block w-full text-right px-4 py-2 hover:bg-gray-100"
                                                        >
                                                            تعديل التقييم
                                                        </button>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </main>

            {/* Modal */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" dir="rtl">
                    <div className="bg-white p-6 rounded-lg w-96">
                        <h2 className="text-lg font-semibold mb-4">
                            {showModal === "price" ? "تعديل نسبة المكسب" :
                                showModal === "status" ? "تعديل الحالة" : "تعديل التقييم"}
                        </h2>
                        {showModal === "status" ? (
                            <select
                                value={inputValue}
                                onChange={(e) => setInputValue(e.target.value)}
                                className="w-full p-2 border border-gray-300 rounded-lg mb-4"
                            >
                                <option value="pending">قيد الانتظار</option>
                                <option value="opened">مفتوح</option>
                                <option value="closed">مغلق</option>
                            </select>
                        ) : (
                            <input
                                type="number"
                                value={inputValue}
                                onChange={(e) => setInputValue(e.target.value)}
                                className="w-full p-2 border border-gray-300 rounded-lg mb-4"
                                placeholder="أدخل القيمة"
                            />
                        )}
                        <div className="flex justify-end gap-2">
                            <button
                                onClick={() => setShowModal(null)}
                                className="px-4 py-2 bg-gray-200 rounded-lg"
                            >
                                إلغاء
                            </button>
                            <button
                                onClick={handleSave}
                                className="px-4 py-2 bg-primary-500 text-white rounded-lg"
                            >
                                حفظ
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Sales;